module.exports = __webpack_public_path__ + "img/jobmule_annunci.a457a4b4.png";